import { ItemView, Model, util } from '@glu/core';
import template from './bulkActions.hbs';

export default ItemView.extend({
  template,

  appEvents: {
    'grid:selectRow': 'initActions',
    'grid:selectAllRows': 'initActions'
  },

  modelEvents: {
    change: 'render'
  },

  events: {
    'click button': 'bulkActionHandler'
  },

  initialize(options) {
    options = options || {};
    this.model = new Model();
    this.columns = options.columns;
    this.bulkActions = options.bulkActions;
    this.gridCid = options.gridCid;
    this.getSelectedRows = options.getSelectedRows;
    this.getSelectedRowModels = options.getSelectedRowModels;
    this.listenTo(this.columns, 'change:condition reset', this.initActions);

    // GLU-1358
    this.listenTo(
      this.collection,
      'reset add remove sort sync',
      // Items need some time to restore their state and some functions which are involved in this
      // process also contain a debounce.
      util.debounce(this.initActions, 50)
    );

    this.initActions();
  },

  onRender() {
    this.toggleBulkActionsVisibility();
  },

  toggleBulkActionsVisibility() {
    this.$el.toggleClass('bulk-actions', this.model.get('showBulkActions'));
  },

  initActions() {
    const bulkActions = this.mapBulkActions(this.bulkActions || this.getBulkActionsFromRowButtons());
    const hasRowSelector = this.hasVisibleRowSelector();

    this.model.set({
      showBulkActions: (bulkActions && bulkActions.length > 0 && hasRowSelector),
      bulkActions,
      bulkActionsDisabled: !this.getSelectedRows().length
    });
  },

  hasVisibleRowSelector() {
    return this.columns.reduce((visibleRowSelector, column) => {
      const condition = column.get('condition');
      // it seems rare that one would have a function for a column level condition as showing and hiding the column would
      // replace the function with a boolean in manageColumnsDialog.js, however row.js tests for this.
      // We cannot pass a model here like it does as this is for all rows not just one
      const visible = !!(util.isFunction(condition) ? condition() : condition !== false);

      return visibleRowSelector || (column.get('type') === 'rowSelector' && visible);
    }, false);
  },

  mapBulkActions(actions) {
    return actions.map(action => {
      const parts = [this.options.id, 'bulk', action.label.replace(/\s+/g, '-').toLowerCase()];
      const filteredByValue = parts.filter(Boolean);

      return {
        ...action,
        qa: filteredByValue.join('-')
      };
    });
  },

  getBulkActionsFromRowButtons() {
    return this.columns.reduce((bulkActions, column) => {
      let rowButtons = column.get('rowButtons');

      if (!util.isArray(rowButtons)) {
        rowButtons = [];
      }

      rowButtons.forEach((rowButton) => {
        if (!rowButton.header && !rowButton.separator && (rowButton.supportsBulkAction || rowButton.bulkActionOnly)) {
          bulkActions.push(rowButton);
        }
      });

      return bulkActions;
    }, []);
  },

  bulkActionHandler(event) {
    const index = this.$(event.target).data('index');
    const action = this.model.get('bulkActions')[index];
    let result;

    event.preventDefault();

    if (action && action.handler) {
      result = action.handler(this.getSelectedRowModels());

      this.appBus.trigger('grid:bulkActionHandled', this.gridCid, action, result);
    }
  }
});
